module.exports = __webpack_public_path__ + "static/media/금남산.7567fc94.jpg";